import { useSurrenderRoot } from 'src/apis/surrender-service/use-surrender-root';
import { PageSpinner } from 'src/components/spinner-container';
import { SurrenderSettingsOverview } from 'src/pages/settings/surrender/overview';
import { SurrenderSettingsTagOverview } from 'src/pages/settings/surrender/tag-overview';

export const SurrenderSettings = () => {
  const surrenderRoot = useSurrenderRoot();

  if (!surrenderRoot.response) return <PageSpinner />;

  if (!surrenderRoot.response.data._links.getSettings)
    return <SurrenderSettingsTagOverview />;
  return <SurrenderSettingsOverview surrenderRoot={surrenderRoot} />;
};
